export const EMPTY_UUID = 'UUID_1301';
export const INVALID_AUTHORIZATION = 'Authorization_4012';
export const NOT_EXISTED_UUID = 'UUID_1102';
export const NOT_MATCHED_UUID = 'UUID_1201';

export default [EMPTY_UUID, INVALID_AUTHORIZATION, NOT_EXISTED_UUID, NOT_MATCHED_UUID]